import { lazy } from "react"
import { Root } from "src/shared/components"
import { FULFILLMENT_PERMISSIONS } from "src/modules/fulfillment/constants/permissions"
import PermissionRoute from "../permission-route"
import { Navigate } from "react-router-dom"

const FulfillmentOrdersList = lazy(() => import("src/modules/fulfillment/pages/FulfillmentOrderList"))
const FulfillmentOrderDetails = lazy(() => import("src/modules/fulfillment/pages/OrderDetails"))
const FulfillmentPicker = lazy(() => import("src/modules/fulfillment/pages/Picker"))
const FulfillmentDispatch = lazy(() => import("src/modules/fulfillment/pages/Dispatch"))
const CarrierManagement = lazy(() => import("src/modules/fulfillment/pages/CarrierManagement"))
const CarrierDetail = lazy(() => import("src/modules/fulfillment/pages/CarrierManagement/detail"))

const fulfillmentRoutes = {
  path: "fulfillment",
  element: <Root />,

  children: [
    {
      index: true,
      element: <Navigate to="/app/fulfillment/orders" />
    },
    {
      path: "orders",
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission={FULFILLMENT_PERMISSIONS.ORDER_READ}>
              <FulfillmentOrdersList />
            </PermissionRoute>
          )
        },
        {
          path: "details/:id",
          element: (
            <PermissionRoute permission={FULFILLMENT_PERMISSIONS.ORDER_DETAILS_READ}>
              <FulfillmentOrderDetails />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "picker",
      element: (
        <PermissionRoute permission={FULFILLMENT_PERMISSIONS.PICKER_READ}>
          <FulfillmentPicker />
        </PermissionRoute>
      )
    },
    {
      path: "dispatch",
      element: (
        <PermissionRoute permission={FULFILLMENT_PERMISSIONS.DISPATCH_READ}>
          <FulfillmentDispatch />
        </PermissionRoute>
      )
    },
    {
      path: "carriers",
      element: <CarrierManagement />
    },
    {
      path: "carriers/:connectionId",
      element: <CarrierDetail />
    }
  ]
}

export default fulfillmentRoutes
